import { render } from "./Workflow.vue?vue&type=template&id=96d0511e&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"

import "./Workflow.vue?vue&type=style&index=0&id=96d0511e&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d0511e"]])

export default __exports__